export enum ModalType {
  Informational = 'Informational',
  Confirmation = 'Confirmation',
}
